/** Справочники для формы автомобиля и фильтров каталога. Значения — стабильные ключи (URL/БД). */

export const BRAND_MODELS: Record<string, readonly string[]> = {
  Audi: [
    "A1", "A3", "A4", "A5", "A6", "A7", "A8", "Q2", "Q3", "Q5", "Q7", "Q8", "e-tron", "TT", "RS3", "RS6", "Другое",
  ],
  BMW: [
    "1 Series", "2 Series", "3 Series", "4 Series", "5 Series", "6 Series", "7 Series", "8 Series", "X1", "X2", "X3",
    "X4", "X5", "X6", "X7", "i3", "i4", "iX", "Z4", "M3", "M5", "Другое",
  ],
  BYD: ["Song Plus", "Tang", "Han", "Seal", "Dolphin", "Atto 3", "Qin", "Другое"],
  Cadillac: ["Escalade", "XT4", "XT5", "XT6", "CT5", "CT6", "Другое"],
  Changan: ["UNI-K", "UNI-T", "CS35", "CS55", "CS75", "Alsvin", "Eado", "Другое"],
  Chery: ["Tiggo 4", "Tiggo 7", "Tiggo 8", "Arrizo 6", "Arrizo 8", "Omoda 5", "Другое"],
  Chevrolet: [
    "Spark", "Nexia", "Cobalt", "Lacetti", "Gentra", "Aveo", "Cruze", "Malibu", "Camaro", "Equinox", "Tracker",
    "Traverse", "Tahoe", "Captiva", "Orlando", "Другое",
  ],
  Citroën: ["C3", "C4", "C5", "C-Elysée", "Berlingo", "Другое"],
  Daewoo: ["Matiz", "Nexia", "Lanos", "Gentra", "Leganza", "Magnus", "Другое"],
  Dacia: ["Sandero", "Duster", "Logan", "Jogger", "Другое"],
  Dongfeng: ["Aeolus", "Rich", "DF6", "Другое"],
  Exeed: ["LX", "TXL", "VX", "RX", "Другое"],
  Fiat: ["500", "Tipo", "Doblo", "Ducato", "Другое"],
  Ford: [
    "Fiesta", "Focus", "Fusion", "Mondeo", "Mustang", "EcoSport", "Kuga", "Edge", "Explorer", "F-150", "Transit",
    "Tourneo", "Другое",
  ],
  GAZ: ["Газель", "Соболь", "Волга", "Другое"],
  Geely: ["Atlas", "Coolray", "Tugella", "Monjaro", "Emgrand", "Vision", "Другое"],
  Genesis: ["G70", "G80", "G90", "GV70", "GV80", "Другое"],
  GreatWall: ["Hover", "Poer", "Wingle", "Другое"],
  Haval: ["H2", "H6", "H9", "Jolion", "F7", "F7x", "Dargo", "Другое"],
  Honda: [
    "Civic", "Accord", "Insight", "Fit", "Jazz", "CR-V", "HR-V", "Pilot", "Odyssey", "Ridgeline", "Другое",
  ],
  Hongqi: ["H5", "H9", "E-HS9", "Другое"],
  Hyundai: [
    "Solaris", "Accent", "Elantra", "Sonata", "i30", "i40", "Creta", "Tucson", "Santa Fe", "Palisade", "Ioniq",
    "Kona", "Venue", "Staria", "Grand Starex", "Другое",
  ],
  Infiniti: ["Q30", "Q50", "QX50", "QX60", "QX70", "QX80", "Другое"],
  Iveco: ["Daily", "Другое"],
  Jac: ["J7", "S3", "T8", "Другое"],
  Jaguar: ["XE", "XF", "F-Pace", "E-Pace", "I-Pace", "Другое"],
  Jeep: ["Renegade", "Compass", "Cherokee", "Grand Cherokee", "Wrangler", "Другое"],
  Jetour: ["X70", "X70 PLUS", "X90", "X90 PLUS", "T2", "Dashing", "Другое"],
  Kia: [
    "Picanto", "Rio", "Cerato", "K5", "Optima", "Stinger", "Soul", "Sportage", "Sorento", "Telluride", "Carnival",
    "Mohave", "EV6", "Niro", "Seltos", "Sonet", "Другое",
  ],
  Lada: [
    "Granta", "Vesta", "XRAY", "Largus", "Niva", "Niva Travel", "Kalina", "Priora", "2110", "2114", "2107", "2106",
    "Другое",
  ],
  "Land Rover": ["Defender", "Discovery", "Discovery Sport", "Range Rover", "Range Rover Sport", "Evoque", "Velar", "Другое",
  ],
  Lexus: ["CT", "IS", "ES", "GS", "LS", "NX", "RX", "GX", "LX", "UX", "LM", "Другое",
  ],
  Lifan: ["X50", "X60", "Solano", "Myway", "Другое"],
  Mazda: ["Mazda2", "Mazda3", "Mazda6", "CX-3", "CX-5", "CX-9", "MX-5", "Другое",
  ],
  "Mercedes-Benz": [
    "A-Class", "B-Class", "C-Class", "E-Class", "S-Class", "CLA", "CLS", "GLA", "GLB", "GLC", "GLE", "GLS", "G-Class",
    "Sprinter", "Vito", "V-Class", "EQC", "EQE", "EQS", "Другое",
  ],
  MG: ["3", "5", "6", "ZS", "HS", "RX8", "Другое"],
  Mini: ["Cooper", "Clubman", "Countryman", "Другое"],
  Mitsubishi: [
    "Mirage", "Lancer", "ASX", "Outlander", "Outlander Sport", "Pajero", "Pajero Sport", "Eclipse Cross", "L200",
    "Другое",
  ],
  Nissan: [
    "Micra", "Note", "Sentra", "Altima", "Maxima", "Leaf", "Juke", "Qashqai", "X-Trail", "Murano", "Patrol", "Navara",
    "Tiida", "Другое",
  ],
  Opel: ["Corsa", "Astra", "Insignia", "Mokka", "Crossland", "Grandland", "Zafira", "Другое",
  ],
  Peugeot: ["108", "208", "301", "308", "408", "508", "2008", "3008", "5008", "Partner", "Expert", "Другое",
  ],
  Porsche: ["911", "718", "Panamera", "Macan", "Cayenne", "Taycan", "Другое",
  ],
  "Range Rover": ["Range Rover", "Range Rover Sport", "Range Rover Evoque", "Range Rover Velar", "Range Rover Vogue", "Другое"],
  Ravon: ["R2", "R4", "Gentra", "Nexia R3", "Другое"],
  Renault: [
    "Logan", "Sandero", "Megane", "Fluence", "Talisman", "Kaptur", "Duster", "Koleos", "Arkana", "Kangoo", "Dokker",
    "Другое",
  ],
  Seat: ["Ibiza", "Leon", "Ateca", "Tarraco", "Другое"],
  Skoda: ["Fabia", "Scala", "Octavia", "Superb", "Kamiq", "Karoq", "Kodiaq", "Rapid", "Другое",
  ],
  Smart: ["Fortwo", "Forfour", "Другое"],
  SsangYong: ["Actyon", "Kyron", "Rexton", "Tivoli", "Korando", "Musso", "Другое",
  ],
  Subaru: ["Impreza", "Legacy", "Outback", "Forester", "XV", "Ascent", "BRZ", "Другое",
  ],
  Suzuki: ["Swift", "Baleno", "SX4", "Vitara", "Grand Vitara", "Jimny", "Ertiga", "Другое",
  ],
  Tank: ["300", "500", "Другое"],
  Tesla: ["Model S", "Model 3", "Model X", "Model Y", "Cybertruck", "Другое",
  ],
  Toyota: [
    "Yaris", "Corolla", "Camry", "Avalon", "Prius", "C-HR", "RAV4", "Highlander", "Land Cruiser", "Land Cruiser Prado",
    "Fortuner", "Hilux", "Tundra", "Sienna", "Alphard", "Hiace", "bZ4X", "Другое",
  ],
  UAZ: ["Patriot", "Pickup", "Hunter", "Буханка", "Другое"],
  Volkswagen: [
    "Polo", "Jetta", "Passat", "Arteon", "Golf", "Tiguan", "Touareg", "Teramont", "Touareg R", "Multivan", "Caddy",
    "Transporter", "Amarok", "ID.4", "ID.6", "Другое",
  ],
  Volvo: ["S60", "S90", "V40", "V60", "V90", "XC40", "XC60", "XC90", "Другое",
  ],
  Voyah: ["Free", "Dream", "Другое"],
  Wey: ["Coffee 01", "Coffee 02", "Tank 300", "Другое"],
  Zeekr: ["001", "009", "X", "Другое"],
  ВАЗ: ["2101", "2106", "2107", "2109", "2110", "2114", "2115", "Приора", "Другое"],
  ГАЗ: ["31105", "Волга", "Другое"],
  УАЗ: ["452", "469", "Патриот", "Другое"],
  ЗАЗ: ["Chance", "Sens", "Vida", "Другое"],
  // Исторические названия марок в объявлениях — сохраняем как отдельные «марки»
  Nexia: ["Nexia 1", "Nexia 2", "Nexia 3", "Другое"],
  Cobalt: ["Cobalt", "Другое"],
  Lacetti: ["Lacetti", "Lacetti Sport", "Другое"],
  Gentra: ["Gentra", "Другое"],
};

export const BRANDS = Object.keys(BRAND_MODELS).sort((a, b) => a.localeCompare(b, "ru"));

export const CAR_COLOR_OPTIONS = [
  { value: "white", label: "Белый" },
  { value: "black", label: "Чёрный" },
  { value: "silver", label: "Серебристый" },
  { value: "gray", label: "Серый" },
  { value: "blue", label: "Синий" },
  { value: "dark_blue", label: "Тёмно-синий" },
  { value: "red", label: "Красный" },
  { value: "burgundy", label: "Бордовый" },
  { value: "green", label: "Зелёный" },
  { value: "brown", label: "Коричневый" },
  { value: "beige", label: "Бежевый" },
  { value: "gold", label: "Золотистый" },
  { value: "orange", label: "Оранжевый" },
  { value: "yellow", label: "Жёлтый" },
  { value: "purple", label: "Фиолетовый" },
  { value: "other", label: "Другой" },
] as const;

export const ENGINE_VOLUME_OPTIONS = [
  "0.8",
  "1.0",
  "1.2",
  "1.3",
  "1.4",
  "1.5",
  "1.6",
  "1.8",
  "2.0",
  "2.2",
  "2.4",
  "2.5",
  "2.7",
  "3.0",
  "3.5",
  "4.0",
  "4.4",
  "5.0",
  "electric",
] as const;

export const BODY_TYPE_OPTIONS = [
  { value: "sedan", label: "Седан" },
  { value: "hatchback", label: "Хэтчбек" },
  { value: "liftback", label: "Лифтбек" },
  { value: "wagon", label: "Универсал" },
  { value: "coupe", label: "Купе" },
  { value: "convertible", label: "Кабриолет" },
  { value: "suv", label: "Внедорожник" },
  { value: "crossover", label: "Кроссовер" },
  { value: "minivan", label: "Минивэн" },
  { value: "pickup", label: "Пикап" },
  { value: "van", label: "Фургон" },
  { value: "other", label: "Другое" },
] as const;

export const CAR_YEAR_MIN = 1990;
export const CAR_YEAR_MAX = 2030;

export function carYearOptions(): number[] {
  const out: number[] = [];
  for (let y = CAR_YEAR_MAX; y >= CAR_YEAR_MIN; y--) out.push(y);
  return out;
}

export function colorLabel(value: string | null | undefined): string {
  if (!value) return "";
  const row = CAR_COLOR_OPTIONS.find((c) => c.value === value);
  return row?.label ?? value;
}

export function bodyTypeLabel(value: string | null | undefined): string {
  if (!value) return "";
  const row = BODY_TYPE_OPTIONS.find((b) => b.value === value);
  return row?.label ?? value;
}

export function engineVolumeLabel(value: string | null | undefined): string {
  if (!value) return "";
  if (value === "electric") return "Электро";
  return `${value} л`;
}

/** Уникальные модели в порядке справочника (без повторов в данных). */
export function modelsForBrand(brand: string): string[] {
  const raw = BRAND_MODELS[brand];
  if (!raw?.length) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const m of raw) {
    if (seen.has(m)) continue;
    seen.add(m);
    out.push(m);
  }
  return out;
}
